import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_AULARIO,
  ALL_AULARIO,
  LOADING_ALL_AULARIO,
} from './AularioReducer';
import {
  allAularioService,
  deleteAularioService,
  oneAularioService,
  saveAularioService,
} from './AularioService';

export const allAularioAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_AULARIO, payload: true });
    const res = await allAularioService(params);
    dispatch({ type: ALL_AULARIO, payload: res.data });
    dispatch({ type: LOADING_ALL_AULARIO, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_AULARIO, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveAularioAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveAularioService(id, data);
    notify(res.data.message);
    await allAularioAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoAularioAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_AULARIO, payload: data });
};

export const oneAularioAction = async (dispatch, id) => {
  try {
    const res = await oneAularioService(id);
    await setActivoAularioAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteAularioAction = async (
  { dispatch, notify },

  id,
  params,
) => {
  try {
    const res = await deleteAularioService(id);
    notify(res.data.message);
    await setActivoAularioAction(dispatch, null);
    await allAularioAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
